import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_EXPENSE_DASHBOARD_FAILURE,
  GET_EXPENSE_DASHBOARD_REQUEST,
  GET_EXPENSE_DASHBOARD_SUCCESS,
} from './expenseManagerDashboard.types';

// Get all expense manager dashboard collections (expenses, vouchers,
// recurring payables and exceptions) in a single aggregate call
export const getExpenseDashboard = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_EXPENSE_DASHBOARD_REQUEST, GET_EXPENSE_DASHBOARD_SUCCESS, GET_EXPENSE_DASHBOARD_FAILURE],
    authenticated: true,
    endpoint: 'api/expense-dashboard',
    method: 'GET',
  },
});
